module.exports = __webpack_public_path__ + "static/media/new-logo.d8455908.svg";